import * as links from 'documents-lib/js/lib/links';
import { trackInteraction } from 'documents-lib/js/tracking/tracker';
import EmptyDocumentThumbnail from 'documents-ui/components/EmptyDocumentThumbnail';
import SummaryHeaderUploadSpinner from './SummaryHeaderUploadSpinner';
import SummaryHeaderPreviewThumbnail from './SummaryHeaderPreviewThumbnail';
import { CLICK_PREVIEW_SUMMARY } from 'documents-lib/js/tracking/actions';
import { Link } from 'foundations-components/transitional/components/Link';
import { Hoverlay } from 'foundations-components/transitional/components/Hoverlay';
import { Image } from 'foundations-components/transitional/components/Image';
import { isUngatedToCHIRPEndpoints } from 'documents-ui/utils/gates';
import { useGetSummaryAnalytics } from '../../hooks/useGetSummaryAnalytics';
import { jsx as _jsx } from "react/jsx-runtime";
const SummaryHeaderImage = ({
  documentId,
  thumbnailUrl: thumbnailUrlREST,
  progressionPercent
}) => {
  var _documentAnalyticsSum, _documentAnalyticsSum2;
  const isUngatedToChirp = isUngatedToCHIRPEndpoints();
  const {
    data: documentAnalyticsSummary
  } = useGetSummaryAnalytics({
    documentId
  });
  const showUploadSpinner = isUngatedToChirp ? documentAnalyticsSummary === null || documentAnalyticsSummary === void 0 || (_documentAnalyticsSum = documentAnalyticsSummary.document) === null || _documentAnalyticsSum === void 0 ? void 0 : _documentAnalyticsSum.isProcessing : progressionPercent;
  const thumbnailUrlCHIRP = documentAnalyticsSummary === null || documentAnalyticsSummary === void 0 || (_documentAnalyticsSum2 = documentAnalyticsSummary.documentAnalyticsSummaryView) === null || _documentAnalyticsSum2 === void 0 ? void 0 : _documentAnalyticsSum2.thumbnailUrl;
  const thumbnailUrl = isUngatedToChirp ? thumbnailUrlCHIRP : thumbnailUrlREST;
  if (showUploadSpinner) {
    return /*#__PURE__*/_jsx(SummaryHeaderUploadSpinner, {});
  }
  let imageNode = /*#__PURE__*/_jsx(EmptyDocumentThumbnail, {});
  if (thumbnailUrl) {
    imageNode = /*#__PURE__*/_jsx(Image, {
      "data-test-id": "summary-header-thumbnail",
      src: thumbnailUrl,
      blockSize: "140px",
      inlineSize: "auto"
    });
  }
  return /*#__PURE__*/_jsx(Link, {
    use: "unstyled",
    href: links.getPreviewURL(documentId),
    target: "_blank",
    onClick: () => trackInteraction(CLICK_PREVIEW_SUMMARY),
    children: /*#__PURE__*/_jsx(Hoverlay, {
      use: "full-card",
      foregroundContent: /*#__PURE__*/_jsx(SummaryHeaderPreviewThumbnail, {}),
      marginInlineEnd: "500",
      children: imageNode
    })
  });
};
export default SummaryHeaderImage;